import { Typography } from '@/components';

import styles from './Branding.module.scss';
import defaultLogoAsset from '../../../../../assets/images/logo.svg';

import type { HeaderData } from '../../types';

type BrandingProps = {
  brand: HeaderData['brand'];
  variant?: HeaderData['variant'];
};

export function Branding({ brand, variant = 'default' }: BrandingProps) {
  const fallbackLogo = {
    url: defaultLogoAsset,
    alt: brand.name,
  };

  const darkLogo = brand.logo || fallbackLogo;
  // The overlay variant sits on the plum gradient, so prefer the light mark.
  const logo = (variant === 'overlay' && brand.logoLight) || darkLogo;
  /*
   * Past the hero the header takes its standard light ground, so the dark mark
   * is rendered alongside the light one and CSS picks between them. Both are
   * fetched up front, so the switch cannot flash, and `.brandLogo` fixes the
   * height for both, so it cannot shift the row either.
   */
  const overlayPair = variant === 'overlay' && logo !== darkLogo ? darkLogo : null;

  return (
    <div className={styles.branding}>
      <a className={`${styles.brandLink} interact-header__brand`} href={brand.url} rel="home">
        {logo ? (
          <>
            <img
              className={`${styles.brandLogo} interact-header__logo interact-header__logo--overlay`}
              src={logo.url}
              alt={logo.alt || brand.name}
            />
            {overlayPair ? (
              <img
                className={`${styles.brandLogo} interact-header__logo interact-header__logo--standard`}
                src={overlayPair.url}
                alt=""
                aria-hidden="true"
              />
            ) : null}
          </>
        ) : (
          <Typography tagName="span" color="var(--color-bg-brand-primary)">
            <strong>{brand.name}</strong>
          </Typography>
        )}
      </a>
      {brand.tagline ? (
        <Typography tagName="span" size="small" color="var(--color-bg-brand-primary)">
          {brand.tagline}
        </Typography>
      ) : null}
    </div>
  );
}
